import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Page404 from "../public/page404"; // 404 page component
import Home from "../public/home";
import { fetchLanguages } from "../../store/actions/languages";
import { useDispatch } from "react-redux";
import Track from "../private/pages/track";

const PageRouter = () => {
  const dispatch = useDispatch();

  const fetchLanguage = () => {
    dispatch(fetchLanguages());
  }

  useEffect(() => {
     fetchLanguage();
  }, [])

  return (
    // BrowserRouter is used for client-side routing
    <BrowserRouter>
      {/* Routes component to define different routes */}
      <Routes>
        {/* Route for the root path, renders the Login component */}
        <Route path="/" element={<Home />} />
        {/* Route for the root path, renders the Start component */}
        <Route path="/track" element={<Track />} />
        {/* Route for the root path, renders the Faq component */}
        {/* <Route path="/faq" element={<Faq />} /> */}
        {/* Route for the root path, renders the Contact component */}
        {/* <Route path="/contact" element={<Contact />} /> */}
        {/* Route for the /imprint path, renders the Imprint component */}
        {/* <Route path="/imprint" element={<Imprint />} /> */}
        {/* Route for the /privacy path, renders the Privacy component */}
        {/* <Route path="/privacy" element={<Privacy />} /> */}
        {/* Route for the /privacy path, renders the Privacy component */}
        {/* <Route path="/settings" element={<Settings />} /> */}
        {/* Catch-all route for any other paths not defined, renders the Page404 component */}
        <Route path="*" element={<Page404 />} />
      </Routes>
    </BrowserRouter>
  );
};

// Export PageRouter component as the default export of the module
export default PageRouter;
